import type { Node } from '@xyflow/react';

/** Whether a node is a tiled leaf (has a value, no children) or a container section. */
export enum TreemapNodeKind {
  Section = 'section',
  Leaf = 'leaf',
}

/** Safe subset of a mermaid `classDef` — only presentational properties we apply. */
export interface TreemapClassStyle {
  fill?: string;
  stroke?: string;
  color?: string;
}

/** Output of the parser — a stable tree that never mutates after parse. */
export interface TreemapTreeNode {
  id: string;
  label: string;
  /** Explicit (leaf) or aggregated bottom-up (section) value. */
  value: number;
  kind: TreemapNodeKind;
  /** Class name from a `:::class` selector, or null. */
  className: string | null;
  children: TreemapTreeNode[];
  depth: number;
}

export interface ParsedTreemap {
  /** Synthetic root wrapping all top-level entries (depth 0). */
  root: TreemapTreeNode;
  title: string | null;
  classDefs: Map<string, TreemapClassStyle>;
}

/** A positioned rectangle in fixed layout-space. */
export interface TreemapRect {
  x: number;
  y: number;
  w: number;
  h: number;
}

/** Data attached to each React Flow node. */
export interface TreemapNodeData {
  nodeId: string;
  label: string;
  value: number;
  kind: TreemapNodeKind;
  depth: number;
  colorIndex: number;
  classStyle: TreemapClassStyle | null;
  showValue: boolean;
  [key: string]: unknown;
}

export type TreemapFlowNode = Node<TreemapNodeData, 'treemapCell'>;
